// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__EEhgz","title":"styles_title__hzrPm"};